<template>
	<v-dialog v-model="dialog" max-width="500" persistent>
		<v-card>
			<v-toolbar flat dense color="info" dark>
				<v-toolbar-title class="subheading text-xs-center">Configure Discussion Points</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar>

			<v-card-text>
                <v-subheader class="text-xs-left">Include the following items as discussion points on the Performance Review:</v-subheader>
                <v-switch v-model="form.includeKPIs">
					<template v-slot:label>
						<div>
							Include KPI's
							<div class="caption">Pulls in the KPI's from the employee's position description</div>
						</div>
					</template>
				</v-switch>
                <v-switch v-model="form.includeKeyDuties">
					<template v-slot:label>
						<div>
							Include Key Duties
							<div class="caption">Pulls in the Key Duties from the employee's position description</div>
						</div>
					</template>
				</v-switch>
				<v-switch v-model="form.includePersonSpecification">
					<template v-slot:label>
						<div>
							Include the Person Specification
							<div class="caption">Pulls in the Person Specification from the employee's position description</div>
						</div>
					</template>
				</v-switch>
                <v-switch v-model="form.includeCoreValues">
					<template v-slot:label>
						<div>
							Include Core Values
							<div class="caption">Include Company Core Values as disucssion points</div>
						</div>
					</template>
				</v-switch>
			</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn flat @click="onCancel"> Cancel </v-btn>
				<v-btn color="primary" flat @click="onConfirm"> Set </v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		props: {
			dialog: {
				type: Boolean,
				required: true
			},
			options: {
				type: Object,
				required: true
			}
		},
		data() {
			return {
                form: null
            };
		},
        created() {
            this.form = JSON.parse(JSON.stringify(this.options));
        },
		methods: {
			onConfirm() {
				this.$emit('onConfirm', this.form);
			},
			onCancel() {
				this.$emit('onCancel');
			}
		}
	};
</script>